exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graphBackBtn {\n  margin-top: 10rem;\n  padding: 2rem;\n  cursor: pointer;\n}\n.chart {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translate(-50%, 0%);\n          transform: translate(-50%, 0%);\n}\n.chart circle {\n  cursor: pointer;\n  stroke: #333;\n}\n.noreceipts {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
